<script>
export default {
    name: "PatientDocumentView",

    props: {

        showModal: Boolean,
        patientDocuments: Array,
    },

    components: {
        "view-patient-document": () => import('./ViewDocument.vue'),
    }

}
</script>
<template>
    <tail-modal :show="showModal" dimension="w-11/12 md:w-1/2">
      <template v-slot:title>
        <h5 class="font-bold text-base">Patient Documents</h5>
      </template>
      <template v-slot:modal-body>
        <div class="w-full flex flex-wrap -m-3">
            <div class="w-full overflow-auto">
                <table class="table table-hover">
                    <thead class="bg-blue-500 text-sm text-white whitespace-no-wrap">
                        <tr class="w-full flex">
                            <th class="p-tiny w-1/3">Doc Ref</th>
                            <th class="p-tiny w-1/3">Name</th>
                            <th class="p-tiny w-1/3">Action</th>
                        </tr>  
                    </thead>
                    <tbody class="text-xs bg-gray-100 flex flex-col items-center overflow-auto" style="height:35vh;">
                        <tr class="w-full flex" v-for="(doc, idx) in patientDocuments" :key="idx">
                            <td class="p-tiny w-1/3">{{ doc.docRef }}</td>
                            <td class="p-tiny w-1/3">{{ doc.docName }}</td>
                            <td class="p-tiny w-1/3">
                                <button 
                                    class="btn-sm btn-primary text-xs rounded" 
                                    @click.prevent="doc.view=true">
                                        <i class="fa fa-eye"></i>
                                </button>
                                <view-patient-document 
                                    :patientDocument="doc" 
                                    :showModal="doc.view" 
                                    @closeModal="doc.view=false" >
                                </view-patient-document>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button class="btn-danger btn-sm text-xs" @click="$emit(`closeModal`)"><i class="fa fa-times"></i> Cancel</button>
      </template>
    </tail-modal>
</template>